// extracted by mini-css-extract-plugin
export default {"modalOverlay":"YC-z","modalContent":"ZC-z","header":"_C-z","close":"aD-z"};